import { RootState } from "@/store/types";
import axios from "axios";
import { ActionTree } from "vuex";
import { DetailFilterParams, GroupFilterParams, StatisticState } from "./types";

export const actions: ActionTree<StatisticState, RootState> = {
  async getEmailStatisticDetail({commit}, filterParams: DetailFilterParams) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/email",
        params: filterParams,
      });
      let messages = resp.data?.messages ?? []
      if (filterParams.page_number > 1) {
        commit("pushEmailStatisticDetail", messages);
      } else {
        commit("setEmailStatisticDetail", messages);
      }
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async exportEmailStatisticDetail({commit}, filterParams: DetailFilterParams) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/email/export",
        params: filterParams,
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getEmailStatisticDetailInfo({ commit, dispatch }, id: string) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/email/" + id.replace(/#/g, "%23"),
      });
      commit("setEmailStatisticDetailInfo", resp?.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getEmailMessage({commit}, id: string) {
    try {
      const resp = await axios({
        url: `/stats-api/detail/email/${id.replace(/#/g, "%23")}/message`,
      })
      return resp.data.message;
    } catch (err) {
      throw err;
    }
  },
  async getEmailEventsStatisticDetail({ commit, dispatch }, {id, filter}) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/email/" + id.replace(/#/g, "%23") + "/events",
        params: filter,
      });
      if (resp?.data?.events)
        commit("setEmailDetailEvents", resp?.data?.events);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async exportEmailEventsStatisticDetail({ commit, dispatch }, {id, filter}) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/email/" + id.replace(/#/g, "%23") + "/events/export",
        params: filter,
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getEmailEventsStatisticDetailInfo({ commit, dispatch }, {message_id, id}) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/email/" + message_id.replace(/#/g, "%23") + "/events/" + id.replace(/#/g, "%23"),
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getEmailStatisticGroup({commit}, filterParams: GroupFilterParams) {
    try {
      const resp = await axios({
        url: "/stats-api/group/email",
        params: filterParams,
      });
      commit("setEmailStatisticGroup", resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async exportEmailStatisticGroup({commit}, filterParams: GroupFilterParams) {
    try {
      const resp = await axios({
        url: "/stats-api/group/email/export",
        params: filterParams,
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getEmailEventsStatisticGroup({commit}, filterParams: GroupFilterParams) {
    try {
      const resp = await axios({
        url: "/stats-api/group/email/events",
        params: filterParams,
      });
      commit("setEmailStatisticGroup", resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async exportEmailEventsStatisticGroup({commit}, filterParams: GroupFilterParams) {
    try {
      const resp = await axios({
        url: "/stats-api/group/email/events/export",
        params: filterParams,
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
};